












import Vue from 'vue'
import {mapActions, mapState} from 'vuex'

export default Vue.extend({
    data: () => ({
        note_modifica: ''
    }),
    computed: {
        ...mapState('reportAdmin', ['segnalazioneSelezionata', 'nuoviDati'])
    },
    methods: {
        ...mapActions('reportAdmin', ['modificaSegnalazione', 'caricaStoriaSegnalazione']),
        ...mapActions('modal', ['showModal']),
        // metodo per modificare una segnalazione
        async salvaModifiche() {
            // modifichiamo la segnalazione con una richiesta patch
            await this.modificaSegnalazione({...this.nuoviDati, note_modifica: this.note_modifica})
            // ricarichiamo la storia della segnalazione
            await this.caricaStoriaSegnalazione(this.segnalazioneSelezionata.id)
            // chiudiamo il modal
            this.showModal(null)
        }
    }
})
